import HeroSection from './components/HeroSection';
import CategoryCards from './components/CategoryCards';
import FeaturedArticles from './components/FeaturedArticles';
import LatestArticles from './components/LatestArticles';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import SchemaOrg from '@/components/base/SchemaOrg';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '亚洲精品一区二区',
  url: 'https://taimudaojia.cn',
  description: '亚洲精品一区二区为您提供专业分区内容导览，涵盖一区精品推荐与二区优质资源，精准分类、快速定位。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://taimudaojia.cn/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <>
      <SchemaOrg data={homeSchema} />
      <main>
        <HeroSection />
        <CategoryCards />
        <FeaturedArticles />
        <LatestArticles />
        <CTASection />
        <FAQSection />
      </main>
    </>
  );
}